import { render, staticRenderFns } from "./guide-card.vue?vue&type=template&id=09054d06&scoped=true&"
import script from "./guide-card.vue?vue&type=script&lang=js&"
export * from "./guide-card.vue?vue&type=script&lang=js&"
import style0 from "./guide-card.vue?vue&type=style&index=0&id=09054d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09054d06",
  null
  
)

export default component.exports